import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBuddyListRequest } from './PeopleTabAPI';
import { RootState } from '../../../../store';
import { FilterOptions } from './PeopleTab';

export type ProfileProps = {
  email: string;
  smallProfileUrl: string;
  banner: {
    imageUrl: string;
    videoUrl: string;
  };
  country: { code: string; name: string; flagUrl: string };
  courseInfo: { courseTitle: string; courseLevel: string; displayName: string };
  description: string;
  firstName: string;
  interests: [{ id: string; url: string; name: string }];
  languages: [{ code: string; name: string; url: string }];
  profession: string;
  largeProfileUrl: string;
  lastName: string;
  mediumProfileUrl: string;
  programme: string;
  rating: string;
  school: string;
  role: string;
  companyName: string;
  department: string;
  type: 'Student' | 'Staff' | 'Alumni' | 'Parent';
  year: string;
  introVideoUrl?: string;
  displayName?: string;
  state?: string;
};

export interface PersonProp {
  createdDate?: [];
  domain?: string;
  id: number;
  posts?: [];
  profile: ProfileProps;
  profileLink: string;
  ratings?: [];
  replyTime: {
    unit: string;
    count: number;
  };
}

interface UniversityBuddyListResponseProp {
  status: string;
  isFetching: boolean;
  buddyListPayload: {
    items: PersonProp[];
    currentPage: number;
    totalItems: number;
    totalPages: number;
  };
}

// Define the initial state using that type
const initialState: UniversityBuddyListResponseProp = {
  status: 'init',
  buddyListPayload: {
    items: [],
    currentPage: 0,
    totalItems: 0,
    totalPages: 0,
  },
  isFetching: false,
};

export type GetBuddyListReq = {
  id: string;
  filterOptions: FilterOptions;
};

export const fetchBuddyListByUniversityId = createAsyncThunk('get/buddy/list', async (req: GetBuddyListReq) => {
  return await getBuddyListRequest(req);
});

// Then, handle actions in your reducers:
const PeopleTabSlice = createSlice({
  name: 'getBuddyList',
  initialState: initialState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: (builder) => {
    // Add reducers for additional action types here, and handle loading state as needed
    builder
      .addCase(fetchBuddyListByUniversityId.pending, (state) => {
        state.status = 'pending';
        state.isFetching = true;
      })
      .addCase(fetchBuddyListByUniversityId.fulfilled, (state, action) => {
        // Add user to the state array
        state.status = 'success';
        state.isFetching = false;
        state.buddyListPayload = action.payload;
      })
      .addCase(fetchBuddyListByUniversityId.rejected, (state) => {
        state.status = 'failed';
        state.isFetching = false;
      });
  },
});

export const getBuddyListSelector = (state: RootState) => state.getUniversityBuddyList;
export default PeopleTabSlice.reducer;
